import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import { StyledTabsLabelsComponent } from "./tabs-labels-component.scss";

const TabsLabelsComponent = ({
  labels,
  selectedLabelIndex,
  progressbarColor,
  transitionTime,
  onSelectionChanges,
  tabLabelHeight
}) => (
  <StyledTabsLabelsComponent
    tabLabelHeight={tabLabelHeight}
    progressbarColor={progressbarColor}
    transitionTime={transitionTime}
    className="tabs-labels-component"
  >
    {labels.map((label, index) => (
      <div
        key={index}
        onClick={() => onSelectionChanges(index)}
        className={classnames("label", { active: !!transitionTime, selected: selectedLabelIndex === index })}
      >
        <AssetComponent image={{ src: label }} />
        <div className="underline-placeholder" />
      </div>
    ))}
  </StyledTabsLabelsComponent>
);

export default TabsLabelsComponent;
